import React, { useState, useEffect } from 'react';
import { handleChange, handleSubmit } from "../../Controller/CreatePartController";
import DiscountTypeService from "../../../Setup/controller/StockCategoryController/StockCategoryController";
import UnitofMeasureService from "../../../Setup/controller/UnitOfMeasureController/UnitOfMeasureController";
import LocationService from "../../../Setup/controller/LocationController/LocationController";
import PartService from "../../Controller/PartController";
import { useNavigate, useLocation } from 'react-router-dom';
import HelpSite from "../../../Common/HelpLink";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import CurrencyTextField from "../../../Jobs/View/JobForms/CurrencyTextField";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import LeadUserDefineFieldsSection from './PartUserDefineSelection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";
function CreatePart({ StockID, Tab, isLock }) {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        ID: 0,
        vc_StockCode: '',
        snt_ItemType: 0,
        vc_Description: '',
        dec_UnitWeight: '0.000',
        dec_MinimumQuantity: '0',
        dec_MaximumQuantity: '999999999',
        mon_SalesPrice: '0.00',
        mon_StockPrice: '0.00',
        mon_LastPurchasePrice: '0.00',
        vc_UnitOfSale: '0',
        vc_Manufacturer: '',
        vc_Barcode: '',
        vc_ManufacturerCode: '',
        bit_BatchManagement: '0', // Change initial state to null
        dec_Density: '1.000',
        snt_SerialTracking: '0', // Change initial state to null
        FK_UnitOfMeasure_ID_Sales: '0',
        FK_UnitOfMeasure_ID_Purchasing: '0',
        ProductBuild: '0', // Change initial state to null
        dec_conversion: '',
        dec_MinimumQuantityDepot: '0.00',
        dec_MaximumQuantityDepot: '0.00'
    });
    const [unitOfMeasureList, setUnitOfMeasure] = useState([]);
    const [DiscountsList, setDiscounts] = useState([]);
    const [LocationList, setLocationData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [showBatchRadio, setShowBatchRadio] = useState(true);
    const [shoewSerialRadio, setShowSerialRadio] = useState(true);
    const [unitsAreSame, setUnitsAreSame] = useState(false);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [StockLocationList, setStockLocation] = useState([]);
    const [loading, setLoading] = useState(true);
    const [value, setValue] = useState('');
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [showPartMessage, setShowPartMessage] = useState(false);
    const [currencySymbol1, setCurrencySymbol1] = useState('');
    const [defCurreny, setCurrency] = useState(null);
    const [currencyValue1, setCurrencyValue1] = useState('');
    const [currencyCostSymbol1, setCostCurrencySymbol1] = useState('');
    const [currencyCostValue1, setCostCurrencyValue1] = useState('');
    const [BaseCurrency, setBaseCurrency] = useState('');
    const [currencyList, setCurrencies] = useState([]);
    const [KeyNameList, setKeyNames] = useState([]);
    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, StockID, "4");
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };

    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);

        // Check if Sale Unit and Purchase Unit are the same
        const { name, value } = event.target;
        let updatedFormData = { ...formData, [name]: value };

        if (name === 'FK_UnitOfMeasure_ID_Sales' || name === 'FK_UnitOfMeasure_ID_Purchasing') {
            const saleUnit = name === 'FK_UnitOfMeasure_ID_Sales' ? value : formData.FK_UnitOfMeasure_ID_Sales;
            const purchaseUnit = name === 'FK_UnitOfMeasure_ID_Purchasing' ? value : formData.FK_UnitOfMeasure_ID_Purchasing;
            const areUnitsSame = saleUnit === purchaseUnit;
            setUnitsAreSame(areUnitsSame);

            if (!areUnitsSame && updatedFormData.dec_conversion === '') {
                updatedFormData.dec_conversion = '1';
            }
        }


        if (name === 'dec_conversion') {
            // Check if the input is a valid decimal number
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_conversion = value;
            } else {
                // If the input is not a valid decimal number, reset the field to the previous value
                updatedFormData.dec_conversion = formData.dec_conversion || '';
            }
        }
        if (name === 'mon_StockPrice') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.mon_StockPrice = value;
            } else {

                updatedFormData.mon_StockPrice = formData.mon_StockPrice || '';
            }
        }
        if (name === 'dec_Density') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_Density = value;
            } else {

                updatedFormData.dec_Density = formData.dec_Density || '';
            }
        }
        if (name === 'mon_SalesPrice') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.mon_SalesPrice = value;
            } else {

                updatedFormData.mon_SalesPrice = formData.mon_SalesPrice || '';
            }
        }
        if (name === 'dec_UnitWeight') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_UnitWeight = value;
            } else {

                updatedFormData.dec_UnitWeight = formData.dec_UnitWeight || '';
            }
        }
        if (name === 'dec_MinimumQuantity') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_MinimumQuantity = value;
            } else {

                updatedFormData.dec_MinimumQuantity = formData.dec_MinimumQuantity || '';
            }
        }
        if (name === 'dec_MaximumQuantity') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_MaximumQuantity = value;
            } else {

                updatedFormData.dec_MaximumQuantity = formData.dec_MaximumQuantity || '';
            }
        }
        if (name === 'dec_Quantity') {
            if (/^\d*$/.test(value)) {
                updatedFormData.dec_Quantity = value;
            } else {

                updatedFormData.dec_Quantity = formData.dec_Quantity || '';
            }
        }
        if (name === 'dec_MaximumQuantityDepot') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_MaximumQuantityDepot = value;
            } else {

                updatedFormData.dec_MaximumQuantityDepot = formData.dec_MaximumQuantityDepot || '';
            }
        }
        if (name === 'dec_MinimumQuantityDepot') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_MinimumQuantityDepot = value;
            } else {

                updatedFormData.dec_MinimumQuantityDepot = formData.dec_MinimumQuantityDepot || '';
            }
        }

        if (name === "FK_UnitOfMeasure_ID_Sales") {
            if (value > 0) {
                const SelectedMeasurement = unitOfMeasureList.find(x => x.ID === parseInt(value));
                if (SelectedMeasurement.DecimalPlaces === 0) {
                    setShowSerialRadio(true);
                    setShowBatchRadio(false);

                }
                else {
                    setShowBatchRadio(true);
                    setShowSerialRadio(false);
                }
            }
            else {
                setShowBatchRadio(true);
                setShowSerialRadio(true);
            }
        }

        setFormData(updatedFormData);
    };

    useEffect(() => {
        fetchCurrency();
        fetchDefaultCurrency();
        fetchDiscount();
        fetchUnitOfMeasure();
        fetchLocations();
        setTableData([]);
        if (StockID === 0) {
            resetForm();
            setStockLocation([]);
            setTableData([]);
            fetchKeyNames();
        } else {
            fetchPartDetail();
            fetchStockLocations();
            fetchKeyNames();
        }

    }, [StockID, Tab]);
    useEffect(() => {
        if (StockLocationList.length > 0) {
            // Populate tableData only if StockLocationList has data
            setTableData(StockLocationList.map((location, index) => ({
                ID: location.PK_StockLocation_ID,
                Depots: location.FK_Location_ID,
                DepotName: location.vc_Name,
                Location: location.vc_BayName,
                Quantity: "0",
                Pending: location.dec_Quantity, // Set quantity to empty string for now
                dec_Allocated: location.dec_Allocated
            })));
            // Set loading to false when data is populated
            setLoading(false);
        }
    }, [StockLocationList, Tab]);
    const fetchDefaultCurrency = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            setCurrency(listOfCurreny);
            setCurrencySymbol1(listOfCurreny[0].Symbol);
            setCurrencyValue1("0.00");
            setCostCurrencySymbol1(listOfCurreny[0].Symbol);
            setCostCurrencyValue1("0.00");
            setBaseCurrency(listOfCurreny[0].Symbol);

        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            setCurrencies(currencyData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchDiscount = async () => {
        try {
            const listOfDiscounts = await DiscountTypeService.GetAllStckCategories();
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };

    const fetchUnitOfMeasure = async () => {
        try {
            const listOfUnits = await UnitofMeasureService.GetAllUnitOfMeasure();
            setUnitOfMeasure(listOfUnits);
        } catch (error) {
            console.error('Error fetching units of measure:', error);
        }
    };

    const fetchLocations = async () => {
        try {
            const listOfLocations = await LocationService.GetAllLocations();
            setLocationData(listOfLocations);
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };
    const fetchStockLocations = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const PartID = StockID;

            const listOfLocations = await PartService.GetPartLocation(redirectCallback, PartID);
            setStockLocation(listOfLocations);
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };
    const location = useLocation();
    const fetchPartDetail = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const PartID = StockID;

            if (PartID > 0) {
                const SupplierDetail = await PartService.GetPartByID(redirectCallback, PartID);

                const formattedDetail = {
                    ...SupplierDetail[0],
                    ProductBuild: String(SupplierDetail[0].ProductBuild), // Convert to string
                    snt_SerialTracking: String(SupplierDetail[0].snt_SerialTracking), // Convert to string
                    bit_BatchManagement: String(SupplierDetail[0].bit_BatchManagement), // Convert to string
                    dec_Quantity: "0",

                };

                setCostCurrencyValue1(SupplierDetail[0].mon_StockPrice);
                setCurrencyValue1(SupplierDetail[0].mon_SalesPrice);

                setFormData(prev => ({
                    ...prev,
                    ...formattedDetail
                }));
                // Handle radio button visibility based on initial values
                setShowBatchRadio(formattedDetail.snt_SerialTracking === "0");
                setShowSerialRadio(formattedDetail.bit_BatchManagement === "0");
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };


    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };

        const redirectUserList = () => {
            navigate('/PartList?saved=true');
        };

        formData.mon_StockPrice = currencyCostValue1;
        formData.mon_SalesPrice = currencyValue1;

        if (StockID === 0) {
            const StockCode = formData.vc_StockCode;
            const AlreadyExist = await PartService.PartAlreadyExist(redirectCallback, StockCode);
            if (AlreadyExist.length > 0) {
                setShowPartMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowPartMessage(false);
                }, 5000);
                return false;
            }
        }
        // Calculate the total quantity
        const sum = tableData.reduce((total, record) => total + parseFloat(record.Quantity), 0);
        const sum1 = tableData.reduce((total, record) => total + parseFloat(record.Pending), 0);
        const sum2 = parseFloat(sum) + parseFloat(sum1);
        setTotalQuantity(sum2);

        const SaleUnit = getUnitName(parseInt(formData.FK_UnitOfMeasure_ID_Sales));
        formData.SaleUnit = SaleUnit;
        formData.sum_Quantity = sum2;

        formData.dec_MinimumQuantityDepot = formData.dec_MinimumQuantity;
        formData.dec_MaximumQuantityDepot = formData.dec_MaximumQuantity;

        if (formData.PK_Stock_ID) {
            formData.ID = formData.PK_Stock_ID;
        }
        else {
            formData.ID = 0;
        }
        // Create the request payload

        const payload = {
            formData: formData,
            tableData: tableData
        };
        const message = await handleSubmit(event, payload, setFormData, setErrors, redirectCallback, redirectUserList);
        if (message == "Data saved successfully") {
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
            localStorage.setItem('HasRecordUpdated', "1");
            setTableData([]);
            fetchPartDetail();
            fetchStockLocations();
            redirectUserList();
            await handleUserDefineSubmit({
                JobID: StockID,
                fields: KeyNameList.map(key => ({
                    PK_KeyName_ID: key.PK_KeyName_ID,
                    value: formData[key.vc_Name] || ''
                }))
            });
            fetchKeyNames();
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }
    };

    const handleRadioChange = (event) => {
        const { name, value } = event.target;

        setFormData({
            ...formData,
            [name]: value
        });

        if (name === "snt_SerialTracking") {
            setShowBatchRadio(value === "0");
        }
        if (name === "bit_BatchManagement") {
            setShowSerialRadio(value === "0");
        }
    };

    const handleAddButtonClick = () => {
        debugger;
        if (!formData.FK_Location_ID || !formData.dec_Quantity) {
            // Show a validation error or alert
            Swal.fire(
                'Error!',
                'Please fill depots and Quantity.',
                'error'
            );
            return false; // Stop execution if any field is empty
        }
        const selectElement = document.querySelector('select[name="FK_Location_ID"]');
        const selectedText = selectElement.options[selectElement.selectedIndex].text;
        const existingRecordIndex = tableData.findIndex(location => String(location.Depots) === String(formData.FK_Location_ID));
        if (existingRecordIndex !== -1) {


            const newPending = parseFloat(tableData[existingRecordIndex].Quantity) + parseFloat(formData.dec_Quantity);

            const updatedRecord = {
                ...tableData[existingRecordIndex], // Keep other properties as they are
                Location: formData.vc_BayName,
                DepotName: selectedText,
                Quantity: newPending.toFixed(2),
                //  Pending: "0.00"
            };

            // Create a new array with the updated record
            const updatedTableData = [
                ...tableData.slice(0, existingRecordIndex),
                updatedRecord,
                ...tableData.slice(existingRecordIndex + 1)
            ];

            // Update the state with the new table data
            setTableData(updatedTableData);
        } else {
            // Add a new record if it doesn't exist
            const newRecord = {
                ID: 0,
                Depots: formData.FK_Location_ID,
                Location: formData.vc_BayName,
                DepotName: selectedText,
                Quantity: formData.dec_Quantity,
                Pending: "0.00"
            };

            // Append the new record to the table data
            setTableData([...tableData, newRecord]);
        }

        setFormData({
            ...formData,
            FK_Location_ID: "0",
            vc_BayName: "",
            dec_Quantity: 0
        })
    };

    const handleRemoveButtonClick = async (id) => {
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };


        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const updatedTableData = tableData.filter(record => record.ID !== id);
                    setTableData(updatedTableData);
                    if (id > 0) {
                        await PartService.DeleteStockLocation(redirectCallback, id);
                    }
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };

    const HelpLink = localStorage.getItem('HelpLink');
    const getUnitName = (unitId) => {
        const unit = unitOfMeasureList.find((unit) => unit.ID === unitId);
        return unit ? unit.Measurment : '';
    };

    const selectedSaleUnit = getUnitName(parseInt(formData.FK_UnitOfMeasure_ID_Sales));
    const selectedPurchaseUnit = getUnitName(parseInt(formData.FK_UnitOfMeasure_ID_Purchasing));

    const conversionText = !unitsAreSame
        ? `1 ${selectedPurchaseUnit} for ${formData.dec_conversion} ${selectedSaleUnit}`
        : '';


    const resetForm = () => {
        debugger;
        setFormData({
            ID: 0,
            vc_StockCode: '',
            snt_ItemType: 0,
            vc_Description: '',
            dec_UnitWeight: '0.000',
            dec_MinimumQuantity: '0',
            dec_MaximumQuantity: '999999999',
            mon_SalesPrice: '0.00',
            mon_StockPrice: '0.00',
            mon_LastPurchasePrice: '0.00',
            vc_UnitOfSale: '0',
            vc_Manufacturer: '',
            vc_Barcode: '',
            vc_ManufacturerCode: '',
            bit_BatchManagement: '0', // Change initial state to null
            dec_Density: '1.000',
            snt_SerialTracking: '0', // Change initial state to null
            FK_UnitOfMeasure_ID_Sales: '0',
            FK_UnitOfMeasure_ID_Purchasing: '0',
            ProductBuild: '0', // Change initial state to null
            dec_conversion: '',
            dec_MinimumQuantityDepot: '0.00',
            dec_MaximumQuantityDepot: '0.00',

        });
    };
    const handleCurrencyChange = ({ symbol, value }) => {
        setCurrencySymbol1(symbol);
        setCurrencyValue1(value);
    };
    const handleCostCurrencyChange = ({ symbol, value }) => {
        setCostCurrencySymbol1(symbol);
        setCostCurrencyValue1(value);
    };
    return (
        <div className="container-fluid p-0">
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <form onSubmit={handleFormSubmit}>
                <div className="card m-2 shadow-sm border-0">
                    <div className="list-group m-2">
                        <div className=" list-group-item d-flex justify-content-between align-items-center">
                            <strong>Description:</strong> {formData.vc_Description}
                        </div>
                         <div className=" list-group-item d-flex justify-content-between align-items-center">
                            <strong>Sale Price:</strong> {formData.mon_SalesPrice}
                        </div>
                        <div className=" list-group-item d-flex justify-content-between align-items-center">
                            <strong>Quantity:</strong> {formData.dec_Quantity}
                        </div>
                         <div className=" list-group-item d-flex justify-content-between align-items-center">
                            <strong>Free Stock:</strong> {formData.dec_FreeStock}
                        </div>
                         <div className=" list-group-item d-flex justify-content-between align-items-center">
                            <strong>Allocated:</strong> {formData.dec_Allocated}
                        </div>
                       
                        <div className=" list-group-item justify-content-between">
                            <button type="submit" className="btn btn-primary" style={{ "marginLeft": "5px", float: "right" }}>
                                <i className="icofont-save" aria-hidden="true">
                                    {StockID > 0 ? ' Update' : ' Save'}
                                </i>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            {/* Action List */}

        </div>
    );
}

export default CreatePart;
